/**
 * Country flags in emojis (22 Oct 2026; option names like "UAE 🇦🇪", and option emojis). Windows draws a flag as
 * two letters ("AE"). Where the browser cannot draw flags, a font of flags only is added (Twemoji's flags, CC-BY 4.0,
 * from the country-flag-emoji-polyfill package, served from our own address). Every font list on the site names it
 * first; it covers flag characters only, so all other text keeps its own font. Browsers that draw flags never load it.
 */
import flagFont from 'country-flag-emoji-polyfill/dist/TwemojiCountryFlags.woff2?url';

export const FLAG_FONT = 'Twemoji Country Flags';
const EMOJI_FONTS = '"Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji","Twemoji Mozilla",sans-serif';

/** Whether the browser draws this emoji in colour (a letter fallback draws the same in black and in white). */
function drawsInColour(text: string): boolean {
  const c = document.createElement('canvas');
  c.width = c.height = 1;
  const g = c.getContext('2d', { willReadFrequently: true });
  if (!g) return true;
  g.textBaseline = 'top';
  g.font = `100px ${EMOJI_FONTS}`;
  g.scale(0.01, 0.01);
  const pixel = (fill: string) => {
    g.clearRect(0, 0, 100, 100);
    g.fillStyle = fill;
    g.fillText(text, 0, 0);
    return g.getImageData(0, 0, 1, 1).data.join(',');
  };
  const white = pixel('#fff');
  const black = pixel('#000');
  return black === white && !black.startsWith('0,0,0,');
}

export function addFlagFont(): void {
  try {
    if (typeof FontFace === 'undefined' || !document.fonts) return;
    if (!drawsInColour('\u{1F60A}') || drawsInColour('\u{1F1E8}\u{1F1ED}')) return;
    const face = new FontFace(FLAG_FONT, `url(${flagFont}) format('woff2')`, {
      unicodeRange:
        'U+1F1E6-1F1FF, U+1F3F4, U+E0062-E0063, U+E0065, U+E0067, U+E006C, U+E006E, U+E0073-E0074, U+E0077, U+E007F',
      display: 'swap',
    });
    document.fonts.add(face);
    void face.load().catch(() => undefined);
  } catch {
    // Flags stay as the browser draws them.
  }
}
